<script lang="ts">
import ProductPaymentForm from '@/components/forms/ProductPaymentForm.vue'
import type { CheckoutContext } from '@/types'
import { type PropType, defineComponent } from 'vue'

import RegisterSignInForm from './RegisterSignInForm.vue'

export default defineComponent({
  components: {
    ProductPaymentForm,
    RegisterSignInForm,
  },
  inheritAttrs: false,
  props: {
    checkoutContext: {
      type: Object as PropType<CheckoutContext>,
      required: true,
    },
    /**
     * Indicates whether the necessary data for the checkout process is ready. If false, the payment form will not be displayed even if the user is logged in.
     * This can be used to prevent rendering the payment form until all required data has been fetched and is available.
     */
    checkoutDataIsReady: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'submit',
    'update:form',
    'update:selectedAction',
    'submitLogin',
    'submitRegister',
    'modalSheetClosed',
    'reservationExpired',
    'paymentProcessingUpdate',
  ],
  methods: {
    handlePaymentProcessingUpdate(isProcessing: boolean) {
      this.$emit('paymentProcessingUpdate', isProcessing)
    },
  },
})
</script>

<template>
  <RegisterSignInForm
    v-if="!$userStore.isLoggedIn"
    v-bind="$attrs"
    @submit-login="$emit('submitLogin')"
    @submit-register="$emit('submitRegister')"
    @update:selected-action="($event) => $emit('update:selectedAction', $event)"
  />

  <div
    v-if="$userStore.isLoggedIn && checkoutDataIsReady"
    class="flex min-h-fit w-full p-6 lg:w-[490px]"
  >
    <ProductPaymentForm
      :checkout-context="checkoutContext"
      :user="$userStore.user!"
      v-bind="$attrs"
      @reservation-expired="$emit('reservationExpired')"
      @payment-processing-update="handlePaymentProcessingUpdate"
    />
  </div>
</template>
